import { useState } from "react";
import { useAuth } from "../lib/auth";
import { ErroApi } from "../lib/api";

export default function Login() {
  const { entrar } = useAuth();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);

  async function enviar(e: React.FormEvent) {
    e.preventDefault();
    setErro("");
    setEnviando(true);
    try {
      await entrar(email, senha);
    } catch (err) {
      setErro(err instanceof ErroApi ? err.message : "Falha ao entrar");
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 16 }}>
      <form onSubmit={enviar} className="cartao" style={{ width: "100%", maxWidth: 380 }}>
        <h1 style={{ fontSize: 20, margin: "0 0 4px" }}>Agendamento 5.0</h1>
        <p style={{ color: "var(--texto-suave)", fontSize: 13, margin: "0 0 20px" }}>
          COCSJC Unidade Sul
        </p>

        {erro && <div className="erro" style={{ marginBottom: 12 }}>{erro}</div>}

        <label className="rotulo" htmlFor="email">E-mail</label>
        <input
          id="email"
          className="campo"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="username"
          required
        />

        <label className="rotulo" htmlFor="senha" style={{ marginTop: 12 }}>Senha</label>
        <input
          id="senha"
          className="campo"
          type="password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          autoComplete="current-password"
          required
        />

        <button className="botao" style={{ width: "100%", marginTop: 20 }} disabled={enviando}>
          {enviando ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
